import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchReportSchemas } from 'api/reports';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';

const useReportSchemas = () => {
    const { accountId } = useCurrentAccount();

    return useSuspenseQuery({
        queryKey: accountQueryKeys.reportSchemas(accountId),
        queryFn: () => fetchReportSchemas(accountId),
        staleTime: Infinity,
    });
};

export { useReportSchemas };
